<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('wallet.walletCenter')"
      @backurl="$router.back()"
    />
    <div class="wallet_wrap">
      <div class="wallet_list">
        
        <!-- 循环卡片列表 -->
        <div
          v-for="(item,index) in withdrawMethod"
          :key="index"
          class="card_box wallet_item"
        >
          <div class="wallet_content">
            
            <!-- 左侧：黄色圆形图标区域 -->
            <div class="icon_wrap">
              <!-- 如果后端有返回图片，就用 item.logo；否则使用内置的银行卡 SVG 占位图 (兼容截图) -->
              <img 
                v-if="item.logo" 
                :src="item.logo" 
                alt="icon"
                class="bank_icon"
              >
              <div v-else class="default_card_icon">
                <div class="card_line"></div>
                <div class="card_chip"></div>
              </div>
            </div>

            <!-- 中间：标题 + 副标题 -->
            <div class="info_mid">
              <div class="main_title">{{ item.name }}</div>
              <div class="sub_tips">{{ item.tips }}</div>
            </div>

            <!-- 右侧：去绑定 / 已绑定 -->
            <div 
              class="action_btn"
              @click="handleRoute(item)"
            >
              <span v-if="!item.status">{{ $t('wallet.toBind') }}</span>
              <span v-else>{{ $t('utils.lunlog39') }}</span>
            </div>

          </div>
        </div>

        <!-- ================= 底部说明文字 ================= -->
        <div class="warning_tips">
          <p class="tip_red">
            <span>*</span>{{ $t('wallet.walletTips1') }}
          </p>
          <p class="tip_gray">
            <span>*</span>{{ $t('wallet.walletTips2') }}
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import { Cell, Tag } from "vant";

Vue.use(Cell).use(Tag);

export default {
  name: "Wallet",
  components: {
    bsHeader
  },
  data() {
    return {
      data: [],
      withdrawMethod: [],
      wallets: []
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    Fetch('/user/getWithdrawalMethod').then(r => {
      this.withdrawMethod = r.data.withdrawMethod;
      this.wallets = r.data.wallets;
      for (var i = 0; i < this.withdrawMethod.length; i++) {
        this.withdrawMethod[i]['status'] = 0;
        this.withdrawMethod[i]['tips'] = this.$t('wallet.bind') + this.withdrawMethod[i]['name'];
        for (var j = 0; j < this.wallets.length; j++) {
          if (this.wallets[j]['wid'] == this.withdrawMethod[i]['id']) {
            this.withdrawMethod[i]['status'] = 1;
            this.withdrawMethod[i]['bank_id'] = this.wallets[j]['id'];
            this.withdrawMethod[i]['tips'] = this.wallets[j]['account'];
            if (this.withdrawMethod[i]['type'] == 4) {
              this.withdrawMethod[i]['name'] = this.wallets[j]['wname'];
              this.withdrawMethod[i]['bank_id'] = this.wallets[j]['id'];
              if (this.wallets[j]['bank']) {
                this.withdrawMethod[i]['logo'] = this.wallets[j]['bank']['logo'];
              }
            }
          }
        }
      }
    })
  },
  methods: {
    // 抽取路由跳转逻辑
    handleRoute(item) {
      if (item.type == 4) {
        this.$router.push('/wallet/bank/' + item.id);
      } else {
        this.$router.push('/wallet/qrcode/' + item.id);
      }
    }
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  min-height: 100vh;
  padding-bottom: 60px;
  
  /* 还原截图的浅蓝网格纹理 */
background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
}

.wallet_wrap {
  padding: 20px 16px 0;
  
  .wallet_list {
    display: flex;
    flex-direction: column;
    gap: 12px; /* 卡片间距 */
  }
}

/* ================= 单张卡片样式 ================= */
.card_box.wallet_item {
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(24, 61, 122, 0.04);
  border: 1px solid rgba(176, 202, 240, 0.3);
  cursor: pointer; /* 增加手型鼠标 */
  transition: transform 0.15s;
  &:active { transform: scale(0.98); }

  .wallet_content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    /* 1. 左侧黄色图标 */
    .icon_wrap {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: #fde047; /* 截图中的淡黄色背景 */
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      margin-right: 14px;

      .bank_icon {
        width: 24px;
        height: 24px;
        object-fit: contain;
      }

      /* 当后端没有返回 logo 时，使用 CSS 画的 "银行卡" 图标 */
      .default_card_icon {
        width: 24px;
        height: 24px;
        background: #ffffff;
        border-radius: 3px;
        position: relative;
        .card_line {
          position: absolute;
          top: 8px;
          left: 4px;
          width: 12px;
          height: 2px;
          background: #fbbf24;
          border-radius: 1px;
        }
        .card_chip {
          position: absolute;
          bottom: 4px;
          right: 4px;
          width: 10px;
          height: 2px;
          background: #fbbf24;
          border-radius: 1px;
        }
      }
    }

    /* 2. 中间文字 */
    .info_mid {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .main_title {
        font-size: 16px;
        font-weight: 600;
        color: #111;
      }
      .sub_tips {
        font-size: 13px;
        color: #64748b;
      }
    }

    /* 3. 右侧操作按钮 */
    .action_btn {
      font-size: 14px;
      color: #64748b;
      font-weight: 500;
      padding: 6px 12px;
      border-radius: 6px;
      background: #f8fafc;
      transition: background 0.2s;
      &:active { background: #f1f5f9; }
      
      span {
        cursor: pointer;
      }
    }
  }
}

/* ================= 底部警告文字 ================= */
.warning_tips {
  margin-top: 24px;
  padding: 0 4px;
  line-height: 1.8;
  font-size: 13px;
  color: #475569;
  
  p {
    display: flex;
    align-items: flex-start;
    gap: 6px;
  }
  
  .tip_red {
    color: #dc2626; /* 红色警告 */
    font-weight: 500;
    span { color: #dc2626; }
  }
  
  .tip_gray {
    color: #475569;
    span { color: #475569; }
  }
}

/* 覆盖 Vant 原本的深色背景样式 */
.van-cell {
  background: transparent !important;
}
</style>